import type React from 'react'

export const MapSvg: React.FC = () => (
  <svg
    enableBackground={`new 0 0 1200 1200`}
    viewBox="0 0 1200 1200"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
  >
    <path d="M0 0h1200v1200H0z" />
    <path
      d="M820.8 811.9H377.1l-78.7 155.3H119l389.2-734.3h183.6L1081 967.2H899.5l-78.7-155.3zm-70.3-136.4-152.1-299-152.1 299h304.2z"
      fill="#fff"
    />
  </svg>
)
